export default __webpack_public_path__ + "static/media/token_main.4a16c6a2.png";